<template>
<m-pageframe
    title="Keyword Auto Response Reporting"
>
<v-container
    fluid
    style="padding-left: 25px; padding-right: 25px;"
>

    <v-text-field
        ref="search"
        v-model="search"
        full-width
        hide-details
        label="Search"
        v-on:input="update()"
        style="margin-bottom: 15px;"
        autocomplete="off"
    >
        <v-icon 
            slot="prepend-inner" 
            style="pointer-events: auto;"
        >
            mdi-magnify
        </v-icon>

        <span
            slot="append-outer"
        >
            <v-menu 
                bottom 
                offset-y  
            >

            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickExport()"
                >
                    <v-list-item-title>Export to Excel...</v-list-item-title>
                </v-list-item>

            </v-list>

            </v-menu> 
          
        </span>

    </v-text-field>

    <v-select
        v-model="keywords"
        :items="all_keywords"
        chips
        label="Keyword(s)"
        multiple
        v-on:change="update"
    >
    </v-select>

    

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
        style="margin-top: 15px;"
    >
    
        <template v-slot:item.from="{ item }">
            {{$rc.pretty(item.from)}}
        </template>

        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.time, 'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.time, 'time')}}
        </template>

        <template v-slot:item.message="{ item }" style="max-width: 400px;">
            {{prettyMessage(item)}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewConversation(item)"
                >
                    <v-list-item-title>View Conversation...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <div
        style="text-align: right; margin-top: 15px;"
    >
        <v-btn
            v-on:click="onClickReturn"
        >
            Return to All Keyword Settings
        </v-btn>
    </div>

    
</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
const E164 = require('@/js/E164.js');
export default 
{
    data() {
        return {
            keywords: [],
            search: null,
            results: [],

            all_keywords: [],

            headers: [
                { text: 'Date', value: 'date'},
                { text: 'Time', value: 'time' },
                { text: 'From', value: 'from' },
                { text: 'First Name', value: 'from_first_name' },
                { text: 'Last Name', value: 'from_last_name' },
                { text: 'Keyword', value: 'keyword' },
                { text: 'Message', value: 'message' },
                { text: 'Action', value: 'action' },
            ],
        }
    },

    mounted () {
        if ( this.$route.params.keyword != null )
            this.keywords = [this.$route.params.keyword];

        this.update();
        this.updateAllKeywords();
    },

    methods: {

        update: _.debounce(function()
        {
            this.$rc.rest(
                'LIST: /keyword-auto-response/reporting',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'keyword' : this.keywords,
                    'full_text' : this.search,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },500),

        updateAllKeywords()
        {
            this.$rc.rest(
                'LIST: /keyword-auto-response/reporting-stats',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                },
            
                (data) => {

                   let all_keywords = [];  

                   for ( let i = 0; i < data.results.length; i++ )
                   {
                       all_keywords.push(data.results[i].keyword);
                   }

                   this.all_keywords = all_keywords;

                   if ( this.$route.params.keyword == null )
                    {
                        // no keyword selected (in link to this page), select them all...
                        this.keywords = _.cloneDeep(this.all_keywords);
                    }
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickExport() {
            this.$rc.excelExport(
                    'EXPORT: /keyword-auto-response/reporting',
                    {
                        search: {
                            'organization_id' : this.$route.params.organization_id,
                            'keyword' : this.keywords,
                        }
                    }
                );
        },

        prettyMessage(item)
        {
            if ( item.auto_response != null ) return item.auto_response;
            return item.error_message;
        },

        removeKeyword(index)
        {
            this.keywords.splice(index,1);
            this.update();
        },

        onClickViewConversation(item)
        {
            
            this.$router.push({
                'name': 'home-routed',
                'params' : {
                    'endpoint' : E164.slimEndpoint(item.from),
                    'conversation_id' : item.conversation_id,
                }
            });
        },

        onClickReturn()
        {
            this.$router.push({
                'name': 'settings-organization-keyword-auto-responses',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                }
            });
        }
    },
    
}
</script>

<style lang="scss" scoped>
</style>